import { GRADE_COLOR } from './_barrel.js';

        // Two-part Admiralty grade badge: a source-reliability letter (A–F,
        // colour-coded) and, when present, the information-credibility digit
        // (1–6). e.g. "B2". Colour is keyed on the letter.
        function ReliabilityBadge({ c }) {
            if (!c.reliability) return null;
            const code = c.admiralty_code || (c.credibility ? `${c.reliability}${c.credibility}` : c.reliability);
            const title = [
                `Source reliability ${c.reliability} — ${c.reliability_label}${c.reliability_rationale ? ` (${c.reliability_rationale})` : ''}`,
                c.credibility && `Info credibility ${c.credibility} — ${c.credibility_label}${c.credibility_rationale ? ` (${c.credibility_rationale})` : ''}`,
            ].filter(Boolean).join('\n');
            return (
                <span title={title}
                    style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        minWidth: '13px', height: '13px', borderRadius: '3px', flex: '0 0 auto',
                        padding: code.length > 1 ? '0 3px' : '0',
                        fontSize: '9px', fontWeight: 700, lineHeight: 1,
                        color: '#0b0b0d', background: GRADE_COLOR[c.reliability] || 'var(--text-muted)',
                    }}>{code}</span>
            );
        }

export { ReliabilityBadge };
